/** Indicador del gesto de recarga (region viva persistente). */
import { clsx } from 'clsx';
import { MobileIcon } from './MobileIcon';

export function PullIndicator({ pulling, refreshing }: { pulling: boolean; refreshing: boolean }) {
  const active = pulling || refreshing;
  return (
    <div role="status" aria-live="polite" className="flex min-h-[8px] justify-center py-2">
      {active && (
        <>
          <MobileIcon
            name={refreshing ? 'sync' : 'arrow_downward'}
            className={clsx('h-6 w-6 text-primary', refreshing && 'animate-spin')}
          />
          <span className="sr-only">{refreshing ? 'Recargando' : 'Suelta para recargar'}</span>
        </>
      )}
    </div>
  );
}
